import buyingPowerCreditBanner from '@/components/oz-buying-power-ldp/assets/folder/buying-power-credit-banner.svg'
import arrow from '@/components/oz-buying-power-ldp/assets/folder/arrow.svg'
import { finCalcBannerClick } from '@/pages/buying-power/buying-power.tracker'
import { mapState } from 'vuex'
import { PARTNERS } from '@/pages/listing/simulatorManagement/constants'

export default {
  name: 'oz-buying-power-credit-banner',
  data () {
    return {
      buyingPowerCreditBanner,
      arrow,
    }
  },
  computed: {
    ...mapState({
      url: (state) => state.partners.url,
      partner: (state) => state.partners.partner,
    }),
  },
  methods: {
    redirect () {
      finCalcBannerClick()
      let partnerUrl = this.url
      if (this.partner === PARTNERS.KZAS || !this.partner) {
        partnerUrl = `${partnerUrl}&utm_content=btn-poder-de-compra`
      }

      window.open(partnerUrl, '_blank').focus()
    },
  },
}
